import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useInternals } from "../../context/internalContext";
import { useUsers } from "../../context/usersContext";
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUnits } from '../../context/unitsContext';
import { toast } from "react-toastify";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/header";
import Titulo from "../../components/Titulo/titulo";
import PageHeader from '../../components/PageHeader';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import Modal from '../../components/modal';
import QuickAddModal from '../../components/modal/quickAddModal';
import TooltipInfo from '../../components/TooltipInfo';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';
import "./trabalho.css";

const MESES = [
  { key: 'jan', label: 'Jan' }, { key: 'fev', label: 'Fev' },
  { key: 'mar', label: 'Mar' }, { key: 'abr', label: 'Abr' },
  { key: 'mai', label: 'Mai' }, { key: 'jun', label: 'Jun' },
  { key: 'jul', label: 'Jul' }, { key: 'ago', label: 'Ago' },
  { key: 'set', label: 'Set' }, { key: 'out', label: 'Out' },
  { key: 'nov', label: 'Nov' }, { key: 'dez', label: 'Dez' },
];

const DIAS_SEMANA = [
  { key: 'sunday', label: 'Dom' },
  { key: 'monday', label: 'Seg' },
  { key: 'tuesday', label: 'Ter' },
  { key: 'wednesday', label: 'Qua' },
  { key: 'thursday', label: 'Qui' },
  { key: 'friday', label: 'Sex' },
  { key: 'saturday', label: 'Sáb' },
];

const PAYMENT_OPTIONS = [
  { value: 'Remissão', label: 'Remição', onlyInterno: true },
  { value: 'Menos de três quartos', label: 'Menos de 3/4 de salário mínimo' },
  { value: 'Entre três quartos e um salário minimo mensal', label: 'Entre 3/4 e 1 salário mínimo' },
  { value: 'Entre um e dois saláriso mínimos', label: 'Entre 1 e 2 salários mínimos' },
  { value: 'Mais de dois salários mínimos', label: 'Mais de 2 salários mínimos' },
  { value: 'Sem informação', label: 'Sem informação' },
];

const TYPE_JOB_REMISSAO = "Disponibilizadas pela administração prisional como apoio ao próprio estabelecimento";
const TYPE_JOB_OPTIONS = [
  "Meios próprios e/ou sem intervenção do sistema prisional",
  "Disponibilizadas pela administração prisional em parceria com a iniciativa privada",
  "Disponibilizadas pela administração prisional em parceria com outros órgãos públicos",
  "Disponibilizadas pela administração prisional em parceria com entidade ou organizações não governamentais sem fins lucrativos",
];

const emptyLaunchForm = {
  start_date: '', end_date: '',
  sunday: false, monday: false, tuesday: false, wednesday: false,
  thursday: false, friday: false, saturday: false,
  studying: '0', regime: '',
};

const emptyWorkForm = {
  start_date: '', end_date: '', type_work: '', firm: '',
  workload: '', sector: '', payment_type: '', observation: '',
  type_of_service: '', type_job: '', location: '',
};

const formatDate = (d) => {
  if (!d) return null;
  const [year, month, day] = d.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('pt-BR');
};
const locationLabel = (l) =>
  l.name || [l.type_space_name, l.type_use_name].filter(Boolean).join(' - ') || `Local ${l.id}`;
const resolveObj = (v) => (v && typeof v === 'object' ? v.name || String(v.id) : v) || null;
const toTitleCase = (str) =>
  str.replace(/\S+/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

const Work = () => {
  const {
    createWork, getWorkByInternalId, updateWork,
    listWorklaunch, createWorklaunch, updateWorklaunch,
    listTypeUse, listTypeSpace, createLocation, listInternalRegime,
  } = useInternals();
  const { listInstitutions, listActivityTypes, createInstitution, createActivityType, listWorkloads } = useAuxiliaries();
  const { listLocations } = useUnits();
  const { userInfo, effectiveUnitId, requireWriteUnit } = useUsers();

  const [showWorkModal, setShowWorkModal] = useState(false);
  const [showLaunchesModal, setShowLaunchesModal] = useState(false);
  const [editingWork, setEditingWork] = useState(null); // null = new, obj = edit

  const [firms, setFirms] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const [internalWorks, setInternalWorks] = useState([]);
  const [regimes, setRegimes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [typeUses, setTypeUses] = useState([]);
  const [typeSpaces, setTypeSpaces] = useState([]);
  const [workloads, setWorkloads] = useState([]);

  const [showLocationModal, setShowLocationModal] = useState(false);
  const [locationModalForm, setLocationModalForm] = useState({ name: '', capacity_use: '', type_use: '', type_space: '' });

  const [selectedInternal, setSelectedInternal] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);

  const [formData, setFormData] = useState(emptyWorkForm);

  // launches state
  const [selectedWorkForLaunches, setSelectedWorkForLaunches] = useState(null);
  const [workLaunches, setWorkLaunches] = useState([]);
  const [launchCounts, setLaunchCounts] = useState({});
  const [launchForm, setLaunchForm] = useState(emptyLaunchForm);
  const [editLaunch, setEditLaunch] = useState(null);
  const [showLaunchForm, setShowLaunchForm] = useState(false);

  const { isSubmitting: isSavingWork, runWithSubmitLock: runSaveWork } = useSubmitLock();
  const { isSubmitting: isSubmittingLaunch, runWithSubmitLock: runSubmitLaunch } = useSubmitLock();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [firmRes, actRes, regRes, locRes] = await Promise.all([
          listInstitutions(), listActivityTypes(), listInternalRegime(), listLocations(),
        ]);
        setFirms(firmRes?.results || []);
        setActivityTypes(actRes?.results || []);
        setRegimes(regRes?.results || []);
        setLocations(locRes?.results || []);
      } catch (e) {
        console.error("Erro ao buscar dados iniciais:", e);
      }
    };
    fetchData();
  }, [listInstitutions, listActivityTypes, listInternalRegime, listLocations]);

  useEffect(() => {
    listTypeUse().then((res) => setTypeUses(res?.results || [])).catch(() => {});
  }, [listTypeUse]);

  useEffect(() => {
    listTypeSpace().then((res) => setTypeSpaces(res?.results || [])).catch(() => {});
  }, [listTypeSpace]);

  useEffect(() => {
    listWorkloads().then((res) => setWorkloads(res?.results || [])).catch(() => {});
  }, [listWorkloads]);

  const loadInternalWorks = async (internal) => {
    try {
      const data = await getWorkByInternalId(internal?.id, internal?.name);
      const works = data?.results || [];
      setInternalWorks(works);

      const counts = await Promise.all(
        works.map((w) => listWorklaunch(w.id).catch(() => null))
      );
      setLaunchCounts(
        works.reduce((acc, w, i) => {
          acc[w.id] = counts[i]?.count ?? counts[i]?.results?.length ?? 0;
          return acc;
        }, {})
      );
    } catch {
      toast.error("Erro ao carregar trabalhos.");
    }
  };

  const handleInternalSelect = async (internal) => {
    if (!internal?.id) { toast.error("Erro ao selecionar interno."); return; }
    setSelectedInternal(internal);
    setShowLaunchesModal(false);
    setSelectedWorkForLaunches(null);
    setWorkLaunches([]);
    await loadInternalWorks(internal);
  };

  // ── Adicionar empresa / local ──

  const handleAddFirm = async (data) => {
    await createInstitution(data);
    const updated = await listInstitutions();
    setFirms(updated?.results || []);
  };

  const handleAddActivityType = async (data) => {
    await createActivityType(data);
    const updated = await listActivityTypes();
    setActivityTypes(updated?.results || []);
  };

  const handleLocationModalChange = (e) => {
    const { name, value } = e.target;
    const transformed = name === 'name' ? toTitleCase(value) : value;
    setLocationModalForm((prev) => ({ ...prev, [name]: transformed }));
  };

  const handleSaveLocation = async (e) => {
    e.preventDefault();
    if (!locationModalForm.name) { toast.warning('Nome é obrigatório.'); return; }
    if (!locationModalForm.type_use) { toast.warning('Tipo de uso é obrigatório.'); return; }
    if (!locationModalForm.type_space) { toast.warning('Tipo de espaço é obrigatório.'); return; }
    const writeUnit = requireWriteUnit();
    if (!writeUnit.ok) { toast.warning(writeUnit.message); return; }
    try {
      const payload = {
        name: locationModalForm.name,
        in_use: true,
        unit: writeUnit.unitId,
        type_use: parseInt(locationModalForm.type_use, 10),
        type_space: parseInt(locationModalForm.type_space, 10),
        ...(locationModalForm.capacity_use ? { capacity_use: parseInt(locationModalForm.capacity_use, 10) } : {}),
      };
      await createLocation(payload);
      toast.success('Local cadastrado com sucesso!');
      const updated = await listLocations();
      setLocations(updated?.results || []);
      setLocationModalForm({ name: '', capacity_use: '', type_use: '', type_space: '' });
      setShowLocationModal(false);
    } catch {
      toast.error('Erro ao cadastrar local.');
    }
  };

  // ── Work modal ──

  const handleOpenNewWork = () => {
    setEditingWork(null);
    setFormData(emptyWorkForm);
    setShowWorkModal(true);
  };

  const handleOpenEditWork = (work) => {
    setEditingWork(work);
    setFormData({
      start_date: work.start_date || '',
      end_date: work.end_date || '',
      type_work: work.type_work || '',
      firm: work.firm?.id || work.firm || '',
      workload: work.workload?.id || work.workload || '',
      sector: work.sector || '',
      payment_type: work.payment_type || '',
      observation: work.observation || '',
      type_of_service: work.type_of_service?.id || work.type_of_service || '',
      type_job: work.type_job || '',
      location: work.location?.id || work.location || '',
    });
    setShowWorkModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === 'type_work') {
        if (value === 'Externo' && prev.payment_type === 'Remissão') {
          updated.payment_type = '';
          updated.location = '';
        }
      }
      if (name === 'payment_type') {
        if (value === 'Remissão') {
          updated.firm = '';
          updated.type_job = TYPE_JOB_REMISSAO;
        } else {
          updated.location = '';
          if (prev.type_job === TYPE_JOB_REMISSAO) updated.type_job = '';
        }
      }
      return updated;
    });
  };

  const handleSaveWork = async (e) => {
    e.preventDefault();
    await runSaveWork(async () => {
      if (!selectedInternal) { toast.error("Selecione um interno."); return; }

      const required = [
        { f: 'type_work', l: 'Tipo de Trabalho' },
        { f: 'start_date', l: 'Data de Início' },
        { f: 'payment_type', l: 'Remuneração' },
        { f: 'sector', l: 'Setor' },
        { f: 'type_of_service', l: 'Função' },
        { f: 'type_job', l: 'Tipo de Vaga' },
        { f: 'workload', l: 'Carga Horária' },
      ];
      for (const { f, l } of required) {
        if (!formData[f]) { toast.warning(`"${l}" é obrigatório.`); return; }
      }

      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) { toast.warning(writeUnit.message); return; }

      const payload = {
        ...formData,
        unit: writeUnit.unitId,
        internal: selectedInternal.id,
        user: userInfo?.id || '',
        workload: formData.workload ? parseInt(formData.workload, 10) : null,
        end_date: formData.end_date || null,
        location: formData.location ? parseInt(formData.location, 10) : null,
        firm: formData.firm || null,
      };

      try {
        if (editingWork) {
          await updateWork(editingWork.id, payload);
          toast.success("Trabalho atualizado com sucesso!");
        } else {
          const res = await createWork(payload);
          if (res.status === 201) toast.success("Trabalho cadastrado com sucesso!");
        }
        setShowWorkModal(false);
        await loadInternalWorks(selectedInternal);
      } catch {
        toast.error("Erro ao salvar trabalho.");
      }
    });
  };

  // ── Launches ──

  const handleGoToLaunches = async (work) => {
    setSelectedWorkForLaunches(work);
    setEditLaunch(null);
    setLaunchForm(emptyLaunchForm);
    setShowLaunchForm(false);
    setShowLaunchesModal(true);
    try {
      const data = await listWorklaunch(work.id);
      setWorkLaunches(data?.results || []);
      setLaunchCounts((prev) => ({ ...prev, [work.id]: data?.count ?? data?.results?.length ?? 0 }));
    } catch {
      toast.error("Erro ao carregar lançamentos.");
    }
  };

  const handleLaunchFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLaunchForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleEditLaunch = (launch) => {
    setEditLaunch(launch);
    setShowLaunchForm(true);
    setLaunchForm({
      start_date: launch.start_date || '',
      end_date: launch.end_date || '',
      sunday: !!launch.sunday, monday: !!launch.monday, tuesday: !!launch.tuesday,
      wednesday: !!launch.wednesday, thursday: !!launch.thursday,
      friday: !!launch.friday, saturday: !!launch.saturday,
      studying: launch.studying ? '1' : '0', regime: launch.regime ?? '',
    });
  };

  const handleCancelLaunch = () => {
    setEditLaunch(null);
    setLaunchForm(emptyLaunchForm);
    setShowLaunchForm(false);
  };

  const handleLaunchSubmit = async (e) => {
    e.preventDefault();
    await runSubmitLaunch(async () => {
      const payload = {
        internal_work: selectedWorkForLaunches.id,
        start_date: launchForm.start_date || null,
        end_date: launchForm.end_date || null,
        sunday: launchForm.sunday, monday: launchForm.monday,
        tuesday: launchForm.tuesday, wednesday: launchForm.wednesday,
        thursday: launchForm.thursday, friday: launchForm.friday,
        saturday: launchForm.saturday,
        studying: launchForm.studying === '1',
        regime: launchForm.regime ? parseInt(launchForm.regime, 10) : null,
      };

      try {
        if (editLaunch) {
          await updateWorklaunch(editLaunch.id, payload);
          toast.success("Lançamento atualizado!");
        } else {
          const res = await createWorklaunch(payload);
          if (res.status === 201) toast.success("Lançamento registrado!");
        }
        setEditLaunch(null);
        setLaunchForm(emptyLaunchForm);
        setShowLaunchForm(false);
        const data = await listWorklaunch(selectedWorkForLaunches.id);
        setWorkLaunches(data?.results || []);
        setLaunchCounts((prev) => ({
          ...prev,
          [selectedWorkForLaunches.id]: data?.count ?? data?.results?.length ?? 0,
        }));
      } catch {
        toast.error("Erro ao salvar lançamento.");
      }
    });
  };

  // ── Computed ──

  const paymentOptions = PAYMENT_OPTIONS.filter(
    (o) => !o.onlyInterno || formData.type_work === 'Interno'
  );

  const isRemissao = formData.payment_type === 'Remissão';

  const formLocations = effectiveUnitId
    ? locations.filter((l) => Number(l.unit) === Number(effectiveUnitId))
    : locations;

  const countInternas = internalWorks.filter((w) => w.type_work === 'Interno').length;
  const countExternas = internalWorks.filter((w) => w.type_work === 'Externo').length;

  // ── Render: work form (used in both create and edit modals) ──
  const renderWorkForm = () => (
    <form onSubmit={handleSaveWork}>
      <div className='social-form-group'>
        <label>Tipo de Trabalho <TooltipInfo text="Indique se a atividade é interna ou externa." /></label>
        <select name="type_work" value={formData.type_work} onChange={handleFormChange} required>
          <option value="">Selecione</option>
          <option value="Interno">Interno</option>
          <option value="Externo">Externo</option>
        </select>
      </div>

      <div className='social-form-group'>
        <label>Remuneração</label>
        <select name="payment_type" value={formData.payment_type} onChange={handleFormChange} required>
          <option value="">Selecione</option>
          {paymentOptions.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>

      {/* Bloco agrupado: datas + local/empresa */}
      <div className="work-form-group-box">
        <div className='social-form-group-duplo'>
          <div className='social-form-group'>
            <label>Data de Início</label>
            <input type="date" name="start_date"
              value={formData.start_date ? formData.start_date.split('T')[0] : ''}
              onChange={handleFormChange} required />
          </div>
          <div className='social-form-group'>
            <label>Data de Fim</label>
            <input type="date" name="end_date"
              value={formData.end_date ? formData.end_date.split('T')[0] : ''}
              onChange={handleFormChange} />
          </div>
        </div>

        {isRemissao ? (
          <div className='social-form-group'>
            <label>Local</label>
            <div className="med-remedy-wrapper">
              <select name="location" value={formData.location || ''} onChange={handleFormChange}>
                <option value="">Selecione</option>
                {formLocations.map((l) => (
                  <option key={l.id} value={l.id}>{locationLabel(l)}</option>
                ))}
              </select>
              <button type="button" className="med-add-remedy-btn" title="Cadastrar novo local"
                onClick={() => setShowLocationModal(true)}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </div>
          </div>
        ) : (
          formData.payment_type && formData.payment_type !== 'Remissão' && (
            <div className='social-form-group'>
              <label>Empresa</label>
              <div className="med-remedy-wrapper">
                <select name="firm" value={formData.firm || ''} onChange={handleFormChange}>
                  <option value="">Selecione</option>
                  {firms.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                </select>
                <QuickAddModal
                  label="Empresa"
                  fields={[
                    { name: 'name', placeholder: 'Nome', type: 'text', transform: toTitleCase },
                    { name: 'cnpj', placeholder: 'CNPJ', type: 'number' },
                  ]}
                  onAdd={handleAddFirm}
                />
              </div>
            </div>
          )
        )}
      </div>

      <div className='social-form-group'>
        <label>Setor Econômico</label>
        <select name="sector" value={formData.sector} onChange={handleFormChange} required>
          <option value="">Selecione</option>
          <option value="Primário">Primário</option>
          <option value="Secundário">Secundário</option>
          <option value="Terciário">Terciário</option>
        </select>
      </div>

      <div className='social-form-group'>
        <label>Função <TooltipInfo text="Selecione a função exercida." /></label>
        <div className="med-remedy-wrapper">
          <select name="type_of_service" value={formData.type_of_service} onChange={handleFormChange} required>
            <option value="">Selecione</option>
            {activityTypes.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          <QuickAddModal
            label="Função"
            fields={[
              { name: 'name', placeholder: 'Nome da função', type: 'text', transform: toTitleCase },
            ]}
            onAdd={handleAddActivityType}
          />
        </div>
      </div>

      <div className='social-form-group'>
        <label>Origem da Vaga</label>
        <select name="type_job" value={formData.type_job} onChange={handleFormChange} required>
          <option value="">Selecione</option>
          {isRemissao ? (
            <option value={TYPE_JOB_REMISSAO}>{TYPE_JOB_REMISSAO}</option>
          ) : (
            TYPE_JOB_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)
          )}
        </select>
      </div>

      <div className='social-form-group'>
        <label>Carga Horária</label>
        <select name="workload" value={formData.workload} onChange={handleFormChange} required>
          <option value="">Selecione</option>
          {workloads.map((w) => (
            <option key={w.id} value={w.id}>{w.hours}h/semana</option>
          ))}
        </select>
      </div>

      <div className='social-form-group'>
        <label>Observações</label>
        <textarea className="textarea-trabalho" name="observation" rows="3"
          value={formData.observation} onChange={handleFormChange} />
      </div>

      <div className="enviar-button-container" style={{ marginTop: 16 }}>
        <button type="submit" className="social-submit-button" disabled={isSavingWork}>
          {isSavingWork ? 'Salvando...' : editingWork ? 'Salvar' : 'Cadastrar'}
        </button>
      </div>
    </form>
  );

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <Titulo children={
          <SearchInternal onSelect={handleInternalSelect} onSelectingChange={setIsSelectingInternal} />
        } />

        <PageHeader
          title="Trabalho"
          subtitle="Cadastro e acompanhamento de atividades laborais."
          internalDetails={selectedInternal}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : !selectedInternal ? (
          <div className="content">
            <p style={{ color: '#888', textAlign: 'center', marginTop: 32 }}>
              Selecione um interno para visualizar.
            </p>
          </div>
        ) : (
          <div className="content">

                {/* Contadores */}
                {internalWorks.length > 0 && (
                  <div className="work-counts">
                    <div className="work-count-card">
                      <span className="work-count-label">Total de atividades</span>
                      <span className="work-count-value">{internalWorks.length}</span>
                    </div>
                    <div className="work-count-card work-count-card--interno">
                      <span className="work-count-label">Internas</span>
                      <span className="work-count-value">{countInternas}</span>
                    </div>
                    <div className="work-count-card work-count-card--externo">
                      <span className="work-count-label">Externas</span>
                      <span className="work-count-value">{countExternas}</span>
                    </div>
                  </div>
                )}

                {/* Botão novo trabalho */}
                {selectedInternal && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
                    <button className="social-submit-button" onClick={handleOpenNewWork}>
                      <FontAwesomeIcon icon={faPlus} /> Novo Trabalho
                    </button>
                  </div>
                )}

                {/* Timeline */}
                {internalWorks.length > 0 ? (
                  <div className="work-timeline">
                    {internalWorks.map((work) => {
                      const isActive = !work.end_date;
                      const startStr = formatDate(work.start_date);
                      const endStr = formatDate(work.end_date);
                      const actType = activityTypes.find(
                        (a) => String(a.id) === String(work.type_of_service?.id || work.type_of_service)
                      );

                      return (
                        <div key={work.id} className="work-timeline-item">
                          <div className={`work-timeline-dot${isActive ? ' work-timeline-dot--active' : ''}`} />

                          <div className="work-timeline-card">
                            {/* Cabeçalho do card */}
                            <div className="work-card-header">
                              <div className="work-card-dates">
                                {startStr} até {endStr || 'Atual'}
                              </div>
                              <div className="work-card-badges">
                                <span className={`work-badge ${isActive ? 'work-badge--active' : 'work-badge--closed'}`}>
                                  {isActive ? 'Em andamento' : 'Encerrado'}
                                </span>
                              </div>
                            </div>

                            {/* Campos do card em grid */}
                            <div className="work-card-grid">
                              <div className="work-card-field">
                                <span className="work-card-field-label">Trabalho</span>
                                <span className="work-card-field-value">{work.type_work || '-'}</span>
                              </div>
                              <div className="work-card-field">
                                <span className="work-card-field-label">Carga Horária</span>
                                <span className="work-card-field-value">
                                  {work.workload_hours ? `${work.workload_hours}h/semana` : '-'}
                                </span>
                              </div>
                              <div className="work-card-field">
                                <span className="work-card-field-label">Setor Econômico</span>
                                <span className="work-card-field-value">{work.sector || '-'}</span>
                              </div>
                              <div className="work-card-field">
                                <span className="work-card-field-label">Origem da Vaga</span>
                                <span className="work-card-field-value">{work.type_job || '-'}</span>
                              </div>
                              <div className="work-card-field">
                                <span className="work-card-field-label">
                                  {work.payment_type === 'Remissão' ? 'Local' : 'Empresa'}
                                </span>
                                <span className="work-card-field-value">
                                  {work.payment_type === 'Remissão'
                                    ? (work.location_name || resolveObj(work.location) || '-')
                                    : (work.firm_name || resolveObj(work.firm) || '-')}
                                </span>
                              </div>
                              <div className="work-card-field">
                                <span className="work-card-field-label">Remuneração</span>
                                <span className="work-card-field-value">
                                  {work.payment_type === 'Remissão' ? 'Remição' : (work.payment_type || '-')}
                                </span>
                              </div>
                              <div className="work-card-field work-card-field--full">
                                <span className="work-card-field-label">Função</span>
                                <span className="work-card-field-value">
                                  {actType?.name || work.type_of_service?.name || '-'}
                                </span>
                              </div>
                            </div>

                            {/* Ações */}
                            <div className="work-card-actions">
                              <button className="work-card-btn" onClick={() => handleOpenEditWork(work)}>
                                <FontAwesomeIcon icon={faPen} /> Editar atividade
                              </button>
                              <button className="work-card-btn work-card-btn--launch" onClick={() => handleGoToLaunches(work)}>
                                <FontAwesomeIcon icon={faPlus} /> Lançamento
                                <span className="launch-count-badge">{launchCounts[work.id] ?? 0}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  selectedInternal && (
                    <p style={{ color: '#888', marginTop: 8 }}>
                      Nenhum trabalho registrado para este interno.
                    </p>
                  )
                )}
          </div>
        )}
      </div>

      {/* Modal cadastro / edição de trabalho */}
      <Modal isOpen={showWorkModal} closeModal={() => setShowWorkModal(false)}>
        <h4>{editingWork ? 'Editar Trabalho' : 'Cadastro de Trabalho'}</h4>
        {renderWorkForm()}
      </Modal>

      {/* Modal cadastro de local */}
      <Modal isOpen={showLocationModal} closeModal={() => setShowLocationModal(false)}>
        <h4>Cadastrar Local</h4>
        <form onSubmit={handleSaveLocation}>
          <div className='social-form-group'>
            <label>Nome</label>
            <input type="text" name="name" value={locationModalForm.name}
              onChange={handleLocationModalChange} required />
          </div>
          <div className='social-form-group'>
            <label>Tipo de Espaço</label>
            <select name="type_space" value={locationModalForm.type_space}
              onChange={handleLocationModalChange} required>
              <option value="">Selecione</option>
              {typeSpaces.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
          <div className='social-form-group'>
            <label>Tipo de Uso</label>
            <select name="type_use" value={locationModalForm.type_use}
              onChange={handleLocationModalChange} required>
              <option value="">Selecione</option>
              {typeUses.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
          <div className='social-form-group'>
            <label>Capacidade (opcional)</label>
            <input type="number" name="capacity_use" value={locationModalForm.capacity_use}
              onChange={handleLocationModalChange} min="0" />
          </div>
          <div className="enviar-button-container" style={{ marginTop: 16 }}>
            <button type="submit" className="social-submit-button">Cadastrar</button>
          </div>
        </form>
      </Modal>

      {/* Modal lançamento de período */}
      <Modal isOpen={showLaunchForm} closeModal={handleCancelLaunch} zIndex={1000}>
        <h4>{editLaunch ? 'Editar Lançamento' : 'Novo Lançamento'}</h4>
        <form onSubmit={handleLaunchSubmit}>

          <div className="launch-period-box">
            <p className="launch-period-box-title">Período</p>
            <div className='social-form-group-duplo'>
              <div className='social-form-group'>
                <label>Início</label>
                <input type="date" name="start_date" value={launchForm.start_date}
                  onChange={handleLaunchFormChange} required />
              </div>
              <div className='social-form-group'>
                <label>Fim</label>
                <input type="date" name="end_date" value={launchForm.end_date}
                  onChange={handleLaunchFormChange} required />
              </div>
            </div>
          </div>

          <div className='social-form-group'>
            <label>Dias trabalhados na semana</label>
            <div className="launch-weekdays-row">
              {DIAS_SEMANA.map(({ key, label }) => (
                <div key={key} className="launch-weekday-cell">
                  <span className="launch-weekday-label">{label}</span>
                  <input type="checkbox" name={key}
                    checked={!!launchForm[key]} onChange={handleLaunchFormChange} />
                </div>
              ))}
            </div>
          </div>

          <div className='social-form-group-duplo'>
            <div className='social-form-group'>
              <label>Regime</label>
              <select name="regime" value={launchForm.regime || ''} onChange={handleLaunchFormChange}>
                <option value="">Selecione</option>
                {regimes.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
              </select>
            </div>
            <div className='social-form-group'>
              <label>Interno estuda?</label>
              <select name="studying" value={launchForm.studying} onChange={handleLaunchFormChange}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </select>
            </div>
          </div>

          <div className="enviar-button-container" style={{ marginTop: 16 }}>
            <button type="submit" className="social-submit-button" disabled={isSubmittingLaunch}>
              {isSubmittingLaunch ? 'Salvando...' : editLaunch ? 'Salvar' : 'Registrar'}
            </button>
          </div>
        </form>
      </Modal>

      {/* Modal lista de lançamentos */}
      <Modal isOpen={showLaunchesModal} closeModal={() => { setShowLaunchesModal(false); setShowLaunchForm(false); }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <h4 style={{ margin: 0 }}>Lançamentos</h4>
            {selectedWorkForLaunches && (() => {
              const totalDias = workLaunches.reduce((acc, l) => acc + (l.total_worked_days ?? 0), 0);
              return (
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, marginTop: 4 }}>
                  <small style={{ color: '#6c757d' }}>
                    {selectedWorkForLaunches.type_of_service?.name || resolveObj(selectedWorkForLaunches.type_of_service) || '-'}
                    {(selectedWorkForLaunches.location_name || resolveObj(selectedWorkForLaunches.location)) && (
                      <> — {selectedWorkForLaunches.location_name || resolveObj(selectedWorkForLaunches.location)}</>
                    )}
                    {' — '}
                    {formatDate(selectedWorkForLaunches.start_date)} até {formatDate(selectedWorkForLaunches.end_date) || 'Atual'}
                  </small>
                  <span className={`work-badge ${!selectedWorkForLaunches.end_date ? 'work-badge--active' : 'work-badge--closed'}`}>
                    {!selectedWorkForLaunches.end_date ? 'Em andamento' : 'Encerrado'}
                  </span>
                  {totalDias > 0 && (
                    <span className="work-badge work-badge--days">
                      {totalDias} {totalDias === 1 ? 'dia trabalhado' : 'dias trabalhados'}
                    </span>
                  )}
                </div>
              );
            })()}
          </div>
          <button className="social-submit-button" style={{ marginLeft: 16 }} onClick={() => {
            setEditLaunch(null);
            setLaunchForm(emptyLaunchForm);
            setShowLaunchForm(true);
          }}>
            <FontAwesomeIcon icon={faPlus} /> Adicionar
          </button>
        </div>

        {workLaunches.length > 0 ? (
          <div className="launch-list">
            {workLaunches.map((launch) => {
              const mesesAtivos = MESES.filter(({ key }) => launch[key]);
              return (
                <div key={launch.id} className={`launch-card${editLaunch?.id === launch.id ? ' launch-card--editing' : ''}`}>
                  <div className="launch-card-highlight">
                    <div className="launch-card-highlight-row">
                      <div>
                        <span className="launch-card-highlight-label">Período</span>
                        <span className="launch-card-period">
                          {formatDate(launch.start_date) || '-'} – {formatDate(launch.end_date) || 'Atual'}
                        </span>
                      </div>
                      <button className="launch-card-edit-btn" onClick={() => handleEditLaunch(launch)}>
                        <FontAwesomeIcon icon={faPen} /> Editar
                      </button>
                    </div>
                    <div>
                      <span className="launch-card-highlight-label">Meses trabalhados</span>
                      <div className="launch-card-months">
                        {mesesAtivos.length > 0
                          ? mesesAtivos.map(({ key, label }) => (
                              <span key={key} className="launch-month-badge">
                                {label} ({launch.worked_days_by_month?.[key] ?? 0})
                              </span>
                            ))
                          : <span style={{ color: '#adb5bd', fontSize: 12 }}>Nenhum mês calculado</span>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="launch-card-info">
                    {launch.regime_name && (
                      <span className="launch-card-info-item">
                        <strong>Regime:</strong> {launch.regime_name}
                      </span>
                    )}
                    <span className="launch-card-info-item">
                      <strong>Estuda:</strong> {launch.studying ? 'Sim' : 'Não'}
                    </span>
                    <span className="launch-card-info-item">
                      <strong>Dias trabalhados:</strong> {launch.total_worked_days ?? 0}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p style={{ color: '#888' }}>Nenhum lançamento registrado.</p>
        )}
      </Modal>

    </div>
  );
};

export default Work;
